// @ts-nocheck

import React, { useEffect, useState } from "react";
import SoftBox from "../../../components/common/softBox";
import SoftTypography from "../../../components/common/softTypography";
import SoftInput from "../../../components/common/softInput";
import SoftButton from "../../../components/common/softButton";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { FormControl, MenuItem, Select } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { toast } from "react-toastify";
import DashboardNavbar from "../../../components/navbars/dashboardNavbar";
import {
  editLocalization,
  getLocalizationById,
} from "../../../features/localization";

// Dummy action creators – replace with your real ones

const EditLocalization = () => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { localization, status } = useSelector(
    (state: any) => state.localization
  );
  // console.log(localization, "localization");
  const [language, setLanguage] = useState("en");
  const [localizationData, setLocalizationData] = useState<ILocalization>({
    key: "",
    language: "en",
    value: "",
  });

  useEffect(() => {
    if (id && language) {
      dispatch(getLocalizationById({ id, lan: language }));
    }
  }, [dispatch, id, language]);
// console.log(localization,'localization')
  useEffect(() => {
    if (localization) {
      setLocalizationData({
        key: localization.key,
        language: localization.language,
        value: localization.value,
      });
    }
  }, [ localization]);
  // console.log(localizationData,'localizationData')

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setLocalizationData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    if (!localizationData.key.trim()) {
      toast.error("Localization key is required.");
      return;
    }
    if (!localizationData.value.trim()) {
      toast.error("Localization value is required.");
      return;
    }
    dispatch(editLocalization({ ...localizationData, lan: language, id }))
      .then((res) => {
        if (editLocalization.rejected.match(res)) {
          toast.error("Failed to update localization.");
        } else {
          toast.success("Localization updated successfully!");
          navigate("/localization");
        }
      })
      .catch(() => {
        toast.error("An unexpected error occurred.");
      });
  };

  return (
    <SoftBox className="language-box">
      <DashboardNavbar />

      <SoftBox>
        <SoftBox mb={2}>
          <SoftTypography variant="h4" fontWeight="bold" textAlign="left">
            Edit Localization
          </SoftTypography>
        </SoftBox>

        <SoftBox component="form" role="form">
          {/* Language Selector */}
          <SoftBox mb={2}>
            <FormControl fullWidth size="small">
              <SoftTypography
                htmlFor="language"
                style={{
                  fontSize: "15px",
                  fontWeight: "500",
                  marginBottom: "10px",
                }}
              >
                Language
              </SoftTypography>
              <Select
                id="language"
                name="language"
                value={language}
                onChange={(e) => {
                  setLanguage(e.target.value);
                  setLocalizationData({
        key:localizationData.key,
        language: e.target.value,
        value: "",
      });
                }}
                IconComponent={KeyboardArrowDownIcon}
                size="small"
                sx={{
                  height: "40px",
                  ".MuiSelect-select": { height: "40px" },
                }}
              >
                <MenuItem value="en">English</MenuItem>
                <MenuItem value="ar">Arabic</MenuItem>
              </Select>
            </FormControl>
          </SoftBox>

          {/* Key Input (Read-only) */}
          <SoftBox mb={2}>
            <SoftTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Localization Key
            </SoftTypography>
            <SoftInput
              type="text"
              name="key"
              value={localizationData.key}
              readOnly
              disabled
            />
          </SoftBox>

          {/* Value Input */}
          <SoftBox mb={2}>
            <SoftTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Localization Value
            </SoftTypography>
            <SoftInput
              type="text"
              name="value"
              value={localizationData.value}
              onChange={handleChange}
              placeholder="Enter localized value"
            />
          </SoftBox>

          {/* Submit Button */}
          <SoftBox mt={4} mb={1}>
            <SoftButton
              variant="gradient"
              color="info"
              fullWidth
              onClick={handleSubmit}
            >
              Submit
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
};

export default EditLocalization;
